import { forwardRef } from 'react';
import { cn } from '../../utils/classNames';
import FileUploadErrorModal from '../../utils/fileUploadErrorModal';
import useXFileUpload from '../../hooks/useXFileUpload';

const disabledClasses = 'cursor-not-allowed';

// The ref is forwarded for hidden inputs a caller opens itself; the overlay-the-button callers ignore it.
const XFileUpload = forwardRef(({
  name,
  accept = 'application/pdf',
  multiple = false,
  disabled = false,
  onFileSelect,
  maxSize = 500 * 1024 * 1024,
  shouldValidate = true,
  className,
  ...props
}, ref) => {
  const { fileErrorList, setFileErrorList, handleChange } = useXFileUpload({
    accept,
    maxSize,
    shouldValidate,
    onFileSelect,
  });

  return (
    <>
      <input
        ref={ref}
        type="file"
        name={name}
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={handleChange}
        className={cn(disabled && disabledClasses, className)}
        {...props}
      />
      {fileErrorList.length > 0 && (
        <FileUploadErrorModal
          fileErrorList={fileErrorList}
          setFileErrorList={setFileErrorList}
        />
      )}
    </>
  );
});

XFileUpload.displayName = 'XFileUpload';

export default XFileUpload;
